<template>
  <v-row justify="center">
    <v-col cols="2" xs="2" sm="2" md="2" lg="2" class="icon-area">
      <v-icon color="white" class="temp-icon">fas fa-thermometer-three-quarters</v-icon>
    </v-col>
    <TopParamBase :num-val="tempVal" unit="℃" @clickAction="clickAction" />
  </v-row>
</template>

<script>
import TopParamBase from '../Molecules/TopParamBase'

export default {
  name: "TopParamWaterTemp",
  data: () => ({}),
  methods: {
    clickAction() {
      this.$emit('clickAction')
    }
  },
  components:{
    TopParamBase
  },
  props:['tempVal' ]
};
</script>

<style scoped>
.icon-area {
  padding: 0 12px 0 12px;
}
.temp-icon {
  padding: 18px 0 0 0;
}
@media screen and (max-width: 350px) {
}
@media screen and (min-width: 351px) and (max-width: 768px) {
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
</style>
